import React from "react";
import { Modal } from "react-bootstrap";
import "./StripePaymentModal.css";
import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

const StripePaymentModal = ({ clientSecret, setClientSecret }) => {
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

  return (
    <div className="loadingModal">
      <Modal
        animation={false}
        backdropClassName="onboarding-custom-backdrop"
        centered
        dialogClassName="custom-onboarding-modal loadingDialog"
        show={true}
      >
        <Modal.Body className="loadingModalBody figma-drop-shadow">
          {clientSecret && (
            <div
              className="backArrowWrap"
              onClick={() => {
                setClientSecret("");
              }}
            >
              <KeyboardBackspaceIcon sx={{ fontSize: 32 }} />
            </div>
          )}
          {/* <div className="loading-4">
            <span className="span1"></span>
            <span className="span2"></span>
            <span className="span3"></span>
          </div> */}
          <EmbeddedCheckoutProvider
            stripe={stripePromise}
            options={{ clientSecret }}
          >
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default StripePaymentModal;
